import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Store } from '@ngrx/store';

import { AccountService } from '../_services/http/account.service';
import { loginActionError, loginActionSuccess, logoutAction } from '../_store/AccountStore/account.store';
import { MainStoreState } from '../_store/mainStoreState';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(private accountService: AccountService, private store: Store<MainStoreState>, private router: Router) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {    
    return this.accountService.profil().pipe(
      map((profile) => {
        if (profile) {
          this.store.dispatch(loginActionSuccess({ payload: profile }));
          return true;
        } else {
          this.store.dispatch(logoutAction());
          this.router.navigate(['/login']);
          return false;
        }
      }),
      catchError(() => {
        this.store.dispatch(loginActionError());
        return of(false);
      })
    );
  }
}
